export default __webpack_public_path__ + "maps-examples-line-gradient-thumbnail-480-a0207f200dfb1e35620c250f803c7ba3.png";